/**
 * Destiny Matrix container with data and visualization.
 */

import { MatrixOctagon } from './MatrixOctagon';
import styles from './DestinyMatrixView.module.css';

interface DestinyMatrixData {
  positions: Record<string, number>;
  lines: Record<string, number[]>;
  center: number;
  family_center: number;
}

interface DestinyMatrixViewProps {
  matrix: DestinyMatrixData;
  onClose?: () => void;
  onInterpret?: () => void;
}

const LINE_NAMES: Record<string, string> = {
  personal_purpose: '🎯 Личное предназначение',
  social_purpose: '🌍 Социальное предназначение',
  money: '💰 Деньги',
  relationships: '💕 Отношения',
  health: '🏥 Здоровье',
  talents: '🌟 Таланты',
};

const ARCANA_NAMES: Record<number, string> = {
  1: 'Маг', 2: 'Жрица', 3: 'Императрица', 4: 'Император',
  5: 'Иерофант', 6: 'Влюблённые', 7: 'Колесница', 8: 'Справедливость',
  9: 'Отшельник', 10: 'Колесо Фортуны', 11: 'Сила', 12: 'Повешенный',
  13: 'Смерть', 14: 'Умеренность', 15: 'Дьявол', 16: 'Башня',
  17: 'Звезда', 18: 'Луна', 19: 'Солнце', 20: 'Суд',
  21: 'Мир', 22: 'Шут',
};

export function DestinyMatrixView({ matrix, onClose, onInterpret }: DestinyMatrixViewProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>🔮 Матрица Судьбы</h2>
        {onClose && (
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        )}
      </div>

      <div className={styles.centers}>
        <div className={styles.centerItem}>
          <span className={styles.centerLabel}>Центр</span>
          <span className={styles.centerValue}>{matrix.center}</span>
          <span className={styles.centerName}>{ARCANA_NAMES[matrix.center]}</span>
        </div>
        <div className={styles.centerItem}>
          <span className={styles.centerLabel}>Род</span>
          <span className={styles.centerValue}>{matrix.family_center}</span>
          <span className={styles.centerName}>{ARCANA_NAMES[matrix.family_center]}</span>
        </div>
      </div>

      <div className={styles.octagonWrapper}>
        <MatrixOctagon matrix={matrix} />
      </div>

      <div className={styles.lines}>
        {Object.entries(matrix.lines).map(([key, values]) => (
          <div key={key} className={styles.lineItem}>
            <div className={styles.lineName}>{LINE_NAMES[key] || key}</div>
            <div className={styles.lineValues}>
              {values.map((v, i) => (
                <span key={i}>
                  {i > 0 && ' → '}
                  <strong>{v}</strong> {ARCANA_NAMES[v]}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {onInterpret && (
        <button className={styles.interpretBtn} onClick={onInterpret}>
          🤖 AI-расшифровка матрицы
        </button>
      )}
    </div>
  );
}
